import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer__grid">
        {/* Лого и реквизиты */}
        <div className="app-footer__block">
          <a href="https://fixatorapp.ru/" target="_blank" rel="noopener noreferrer" className="app-footer__logo">
            <img src="/img/logo-fixator.svg" alt="Fixator — Защита Ваших авторских прав" />
          </a>
          <p className="app-footer__company">ООО «КупиПрава»</p>
          <p className="app-footer__inn">ИНН 7735208230</p>
          <div className="app-footer__legal">
            <a href="https://fixatorapp.ru/privacy-policy/" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a>
            <a href="https://fixatorapp.ru/user-agreement/" target="_blank" rel="noopener noreferrer">Пользовательское соглашение</a>
            <a href="https://fixatorapp.ru/privacy-consent/" target="_blank" rel="noopener noreferrer">Согласие на обработку персональных данных</a>
            <a href="https://fixatorapp.ru/marketing-consent/" target="_blank" rel="noopener noreferrer">Согласие на получение рекламной информации</a>
          </div>
        </div>

        {/* Навигация */}
        <div className="app-footer__block">
          <nav aria-label="Меню подвала">
            <ul className="app-footer__list">
              <li><a href="https://fixatorapp.ru/" target="_blank" rel="noopener noreferrer">Главная</a></li>
              <li><a href="https://fixatorapp.ru/about/" target="_blank" rel="noopener noreferrer">О сервисе</a></li>
              <li><a href="https://fixatorapp.ru/cases/" target="_blank" rel="noopener noreferrer">Кейсы</a></li>
              <li><a href="https://fixatorapp.ru/plans/" target="_blank" rel="noopener noreferrer">Тарифы</a></li>
              <li><a href="https://fixatorapp.ru/blog/" target="_blank" rel="noopener noreferrer">Блог</a></li>
              <li><a href="https://fixatorapp.ru/contacts/" target="_blank" rel="noopener noreferrer">Контакты</a></li>
            </ul>
          </nav>
        </div>

        {/* Контакты */}
        <div className="app-footer__block">
          <p className="app-footer__contacts-title">Контакты</p>
          <p className="app-footer__contacts-sub">Звонок по России бесплатный</p>
          <p className="app-footer__phone">
            <a href="tel:+79300357909">+7 (930) 035-79-09</a>
          </p>
          <p className="app-footer__contact-row">
            <a href="https://fixatorapp.ru/contacts/" target="_blank" rel="noopener noreferrer">Обратный звонок</a>
          </p>
          <p className="app-footer__contacts-title">Электронная почта</p>
          <p className="app-footer__contact-row">
            <a href="mailto:fixator@buyrights.ru">fixator@buyrights.ru</a>
          </p>
          <p className="app-footer__contacts-title">Адрес</p>
          <p className="app-footer__address">124482, город Москва, г. Зеленоград, к. 305</p>
        </div>

        {/* Медиа и мессенджеры */}
        <div className="app-footer__block">
          <img src="/img/skolkovo-optimized.png" alt="Сколково" className="app-footer__skolkovo" />
          <p className="app-footer__messengers-label">Мессенджеры</p>
          <div className="app-footer__messengers">
            <a
              href="https://wa.me/79919879839?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5%21%20%D0%A5%D0%BE%D1%87%D1%83%20%D0%B7%D0%B0%D1%84%D0%B8%D0%BA%D1%81%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%20%D0%BD%D0%B0%D1%80%D1%83%D1%88%D0%B5%D0%BD%D0%B8%D0%B5"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <img src="/img/icon-whatsapp-optimized.png" alt="WhatsApp" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

